module.exports = __webpack_public_path__ + "assets/img/logo.848f8d51.png";